import { render } from "./ModalNominas.vue?vue&type=template&id=422c8d1a"
import script from "./ModalNominas.vue?vue&type=script&lang=js"
export * from "./ModalNominas.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__